import * as React from "react";

import ClientsLayout from "../components/ClientsLayout"



const UnverifiedClients: React.SFC = () => {
  return (
    <ClientsLayout/>
  );
};

export default UnverifiedClients;
